export default __webpack_public_path__ + "47d1de7385860064766b22a073262189.gif";